import { PagesLink } from "./PagesLink"
import React from "react";
import {FASTYPE_VERSION} from "../../../constants/CONST";
import {Link} from "react-router-dom";
import {Logo} from "../logo/logo";


type SideBarType = {
    marginTop?: boolean;
}

export const SideBar: React.FC<SideBarType> = ({
   marginTop = false
}) => {

    return (
        <div className="flex h-full">
            <div className={"flex flex-col w-48 p-4 gap-12 " + (marginTop ? "mt-12" : "") }>
                <Logo/>

                <PagesLink/>

                <div className="py-4">
                    <Link to="/mention-legales">
                        <p className=" opacity-50 text-xs">
                            Mentions légales
                        </p>
                    </Link>
                    <p className="opacity-50 text-xs">
                        {FASTYPE_VERSION}
                    </p>
                </div>

            </div>
        </div>
    )
}
